module.exports = __webpack_public_path__ + "static/logo-ab683aa24cb10d2f91dbe822e3b2feeb.svg";